<component :is="notification.type" :notification="notification"></component>